<template>
  <f7-block>
    <f7-popup
      class="new-pale-popup scan-palet-data-popup"
      :close-by-backdrop-click="true"
      :opened="popupOpened"
      @popup:closed="popupOpened = false"
    >
      <f7-page>
        <div class="head-popup">
          <f7-row>
            <f7-col width="80">
              <div class="head-text">
                {{ $t('commercialization.picking.palletizing.paleData.title') }}
              </div>
            </f7-col>
            <f7-col width="20">
              <div class="head-btn">
                <f7-button
                  popup-close
                >
                  <img
                    alt="iconCancel"
                    src="@/static/icons/ic_cancel_dark.svg"
                  >
                </f7-button>
              </div>
            </f7-col>
          </f7-row>
        </div>
        <div
          v-if="dataPale != null"
          class="popup-info"
        >
          <div class="popup-info_fila">
            {{ $t('commercialization.picking.palletizing.paleData.labels.serialNumber').toUpperCase() }}
            <div class="popup-info_valor">
              {{ dataPale?.NumeroSerie ?? '' }}
            </div>
          </div>
          <div
            v-if="dataPale.InfoProducto != null"
            class="popup-info_fila"
          >
            {{ $t('common.product').toUpperCase() }}
            <div class="popup-info_valor">
              <span>{{ dataPale.InfoProducto.Descripcion }} </span>
            </div>
          </div>
          <div
            v-if="dataPale.InfoEnvase != null"
            class="popup-info_fila"
          >
            {{ $t('common.package').toUpperCase() }}
            <div class="popup-info_valor">
              <span>{{ dataPale.InfoEnvase.Nombre }} </span>
            </div>
          </div>
          <div
            v-if="dataPale.InfoPale != null"
            class="popup-info_fila"
          >
            {{ $t('common.pallet').toUpperCase() }}
            <div class="popup-info_valor">
              <span>{{ dataPale.InfoPale.Nombre }} </span>
            </div>
          </div>
          <div class="popup-info_fila">
            {{ $t('commercialization.picking.palletizing.paleData.labels.manufactureDate').toUpperCase() }}
            <div class="popup-info_valor">
              <span v-if="dataPale?.FechaFabricacion != null">{{ manufacturingDate }} </span>
            </div>
          </div>
        </div>
      </f7-page>
    </f7-popup>
  </f7-block>
</template>

<script>
import { LogDetails as Log } from '@/js/common/HIDebuggingSupport';
import SoporteFechaYHora from '@/js/common/HIConversionSupport';

export default {
  name: 'PCPopupPaleData',

  data() {
    return {
      popupOpened: false,
      dataPale: null,

    };
  },
  computed: {
    manufacturingDate() {
      const { dataPale } = this;
      if (dataPale && dataPale.FechaFabricacion) {
        const date = dataPale.FechaFabricacion;
        return `${SoporteFechaYHora.obtenerDDMMAA(date)} ${SoporteFechaYHora.obtenerHHMMSS(date)}`;
      }
      return '';
    },
  },

  methods: {
    /**
     * @public
     * @returns {void}
     */
    Show(pale) {
      Log(this, this.Show.name);
      this.dataPale = pale;

      this.popupOpened = true;
    },
    ObtenerProductoDelPale(objPale) {
      Log(this, this.ObtenerProductoDelPale.name);
      const tempProducto = objPale.Existencias.find((e) => e.Articulo.TipoArticulo === 'Producto');
      return tempProducto.Articulo.Descripcion;
    },
    ObtenerCantidadEnvasesDelPale(objPale) {
      Log(this, this.ObtenerCantidadEnvasesDelPale.name);
      const tempEnvase = objPale.Existencias.find((e) => e.Articulo.TipoArticulo === 'Envase');
      return tempEnvase.Cantidad;
    },
  },
};
</script>

<style scoped lang="scss">
.scan-palet-data-popup {
  width: 650px;
  height: 500px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -250px;
  margin-left: -325px;
  border-radius: 4px;
}

.head-popup {
  background: #dfe1e5;
}

.head-btn {
  width: 50px;
  height: 50px;
  float: right;
}

.head-text {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: var(--his-steel-blue);
  margin-top: 15px;
  margin-left: 15px;
}

.popup-add-palet-footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}

.popup-search {
  width: 350px;
  height: 35px;
  margin-left: 25px;
}

.searchPale {
  height: 75px;
}

.btn-popup-cancel {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #c1c1c1;
  width: 150px;
}

.popup-info {
  padding: 20px;

  &_fila {
    font-family: "Roboto Medium";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: var(--his-oliva);
    margin-bottom: 20px;
    margin-top: 20px;
  }

  &_valor {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    line-height: 20px;
    color: var(--his-steel-blue);
    mix-blend-mode: normal;
    margin-top: 10px;
  }
}
</style>
